import React, { Component } from "react"
import { translate } from "react-translate"
import { Link } from "react-router-dom"
import GridColumn, {
  List,
  Menu,
  Grid,
  Form,
  Button,
  Segment,
  Icon
} from "semantic-ui-react"

import "./ProFooterComponent.css"

class ProFooterComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    let { t } = this.props

    return (
      <div id="ProFooter">
        <Grid
          relaxed
          inverted
          stackable
          columns={4}
          padded
          id="proFootercolumn"
        >
          <Grid.Column textAlign="left" mobile={16} tablet={8} computer={4}>
            <Menu text vertical id="textInFooter">
              <Menu.Item header className="ui.vertical.text.menu .header.item">
                {t("category_navigation")}
              </Menu.Item>
              <List relaxed inverted link>
                <Link to={{ pathname: "/mtpro" }}>
                  <List.Item as="a" id="text">
                    {t("label_navigation_accueil")}
                  </List.Item>
                </Link>
                <Link to={{ pathname: "/mtpro/clients" }}>
                  <List.Item as="a" id="text">
                    {t("label_navigation_client")}
                  </List.Item>
                </Link>
                <Link to={{ pathname: "/mtpro/devis" }}>
                  <List.Item as="a" id="text">
                    {t("label_navigation_devis_facture")}
                  </List.Item>
                </Link>
                <Link to={{ pathname: "/mtpro/materiaux" }}>
                  <List.Item as="a" id="text">
                    {t("label_navigation_materiau_ouvrage")}
                  </List.Item>
                </Link>
              </List>
            </Menu>
          </Grid.Column>

          <Grid.Column textAlign="left" mobile={16} tablet={8} computer={4}>
            <Menu text vertical>
              <Menu.Item header className="ui.vertical.text.menu .header.item">
                {t("category_resources")}
              </Menu.Item>
              <List relaxed inverted link>
                <List.Item as="a" id="text">
                  {t("label_resources_support")}
                </List.Item>
                <List.Item as="a" id="text">
                  {t("label_resources_mention")}
                </List.Item>
                <List.Item as="a" id="text">
                  {t("label_resources_politique")}
                </List.Item>
                <List.Item as="a" id="text">
                  {t("label_resources_terme")}
                </List.Item>
              </List>
            </Menu>
          </Grid.Column>

          <Grid.Column textAlign="left" mobile={16} tablet={8} computer={4}>
            <Menu text vertical>
              <Menu.Item header className="ui.vertical.text.menu .header.item">
                {t("category_getintouch")}
              </Menu.Item>
              <List relaxed inverted link>
                <List.Item as="a" id="text">
                  {t("label_getintouch_tel")}
                </List.Item>
                <List.Item as="a" id="text">
                  <Icon
                    circular
                    name="facebook"
                    size="small"
                    className="facebookIcon"
                  />
                  {t("label_getintouch_facebook")}
                </List.Item>
                <List.Item as="a" id="text">
                  <Icon
                    circular
                    name="twitter"
                    size="small"
                    className="twitterIcon"
                  />
                  {t("label_getintouch_twitter")}
                </List.Item>
                <List.Item as="a" id="text">
                  <Icon
                    circular
                    name="linkedin"
                    size="small"
                    className="linkedinIcon"
                  />
                  {t("label_getintouch_linkedin")}
                </List.Item>
              </List>
            </Menu>
          </Grid.Column>

          <Grid.Column textAlign="left" mobile={16} tablet={8} computer={4}>
            <Menu text vertical>
              <Menu.Item header className="ui.vertical.text.menu .header.item">
                {t("category_newsletter")}
              </Menu.Item>
              <List relaxed inverted link>
                <List.Item as="a" id="text">
                  {t("label_description")}
                </List.Item>
                <Form id="newsletter">
                  <Form.Input
                    type="email"
                    action={{ icon: "long arrow right" }}
                    placeholder={t("placeholder_input_mail")}
                  />
                </Form>
              </List>
            </Menu>
          </Grid.Column>
        </Grid>
        <Segment id="textedDownFooter">{t("label_reserved")}</Segment>
      </div>
    )
  }
}

export default translate("ProFooterComponent")(ProFooterComponent)



// WEBPACK FOOTER //
// ./src/components/Pro/Footer/ProFooterComponent.jsx